import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {AboutUsComponent} from './about-us/about-us.component';
import {CommentService} from './classes/comment.service';
import {CommentComponent} from './comment/comment.component';
import {ContactComponent} from './contact/contact.component';
import {WhoWeAreRoutingModule} from './who-we-are-routing.module';
import {WhoWeAreComponent} from './who-we-are.component';

@NgModule({
    imports: [
        SharedModule,
        FormsModule,

        WhoWeAreRoutingModule
    ],
    declarations: [AboutUsComponent, ContactComponent, CommentComponent, WhoWeAreComponent],
    providers: [CommentService]
})
export class WhoWeAreModule {
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/who-we-are.module.ts